export const blogData = [
    {
        id: 1,
        title: 'The Future of AI in Digital Marketing',
        excerpt: 'Discover how artificial intelligence is revolutionizing marketing strategies and customer engagement.',
        author: 'Sarah Johnson',
        date: '2025-08-15',
        category: 'Trends',
        readTime: '5 min read'
    },
    {
        id: 2,
        title: '10 SEO Strategies That Actually Work in 2025',
        excerpt: 'Stay ahead of the curve with these proven SEO tactics that drive real results.',
        author: 'Michael Chen',
        date: '2025-08-10',
        category: 'SEO',
        readTime: '7 min read'
    },
    {
        id: 3,
        title: 'Building Brand Trust Through Authentic Content',
        excerpt: 'Learn how to create content that resonates with your audience and builds lasting trust.',
        author: 'Emma Williams',
        date: '2025-08-05',
        category: 'Content',
        readTime: '6 min read'
    }
];

export const blogDetailsData = [
    {
        id: 1,
        fullContent: [
            {
                type: 'paragraph',
                content: 'In the rapidly evolving landscape of digital marketing, artificial intelligence has become more critical than ever. As we navigate through 2025, businesses must adapt to new technologies and changing consumer behaviors to stay competitive.'
            },
            {
                type: 'heading',
                content: 'Understanding the Current Landscape'
            },
            {
                type: 'paragraph',
                content: 'The digital marketing ecosystem has undergone significant transformations in recent years. With the rise of artificial intelligence, machine learning, and advanced analytics, marketers now have unprecedented tools at their disposal to understand and engage with their audiences.'
            },
            {
                type: 'paragraph',
                content: 'However, with great power comes great responsibility. As these technologies become more sophisticated, so do consumer expectations. Today\'s audiences demand personalized, relevant, and timely content that speaks directly to their needs and interests.'
            },
            {
                type: 'heading',
                content: 'Key Strategies for Success'
            },
            {
                type: 'list',
                items: [
                    'Leverage data analytics to understand your audience deeply',
                    'Create authentic, value-driven content that resonates',
                    'Embrace emerging technologies while maintaining human connection',
                    'Build trust through transparency and consistency',
                    'Optimize for mobile-first experiences',
                    'Focus on long-term relationships over short-term gains'
                ]
            },
            {
                type: 'heading',
                content: 'The Role of Technology'
            },
            {
                type: 'paragraph',
                content: 'Technology should be viewed as an enabler, not a replacement for human creativity and strategic thinking. The most successful digital marketing campaigns combine cutting-edge tools with compelling storytelling and genuine human insight.'
            },
            {
                type: 'paragraph',
                content: 'Automation can handle repetitive tasks and provide valuable data, but the interpretation of that data and the creation of meaningful strategies still requires human expertise and creativity.'
            },
            {
                type: 'heading',
                content: 'Looking Ahead'
            },
            {
                type: 'paragraph',
                content: 'As we move forward, the digital marketing landscape will continue to evolve. Staying informed, adaptable, and customer-focused will be key to success. Remember that at the heart of every successful campaign is a deep understanding of your audience and a commitment to delivering genuine value.'
            },
            {
                type: 'paragraph',
                content: 'Whether you\'re just starting your digital marketing journey or looking to refine your existing strategies, the principles remain the same: know your audience, provide value, and never stop learning.'
            }
        ]
    },
    {
        id: 2,
        fullContent: [
            {
                type: 'paragraph',
                content: 'In the rapidly evolving landscape of digital marketing, SEO strategies have become more critical than ever. As we navigate through 2025, businesses must adapt to new technologies and changing consumer behaviors to stay competitive.'
            },
            {
                type: 'heading',
                content: 'Understanding the Current Landscape'
            },
            {
                type: 'paragraph',
                content: 'The digital marketing ecosystem has undergone significant transformations in recent years. With the rise of artificial intelligence, machine learning, and advanced analytics, marketers now have unprecedented tools at their disposal to understand and engage with their audiences.'
            },
            {
                type: 'paragraph',
                content: 'However, with great power comes great responsibility. As these technologies become more sophisticated, so do consumer expectations. Today\'s audiences demand personalized, relevant, and timely content that speaks directly to their needs and interests.'
            },
            {
                type: 'heading',
                content: 'Key Strategies for Success'
            },
            {
                type: 'list',
                items: [
                    'Leverage data analytics to understand your audience deeply',
                    'Create authentic, value-driven content that resonates',
                    'Embrace emerging technologies while maintaining human connection',
                    'Build trust through transparency and consistency',
                    'Optimize for mobile-first experiences',
                    'Focus on long-term relationships over short-term gains'
                ]
            },
            {
                type: 'heading',
                content: 'The Role of Technology'
            },
            {
                type: 'paragraph',
                content: 'Technology should be viewed as an enabler, not a replacement for human creativity and strategic thinking. The most successful digital marketing campaigns combine cutting-edge tools with compelling storytelling and genuine human insight.'
            },
            {
                type: 'paragraph',
                content: 'Automation can handle repetitive tasks and provide valuable data, but the interpretation of that data and the creation of meaningful strategies still requires human expertise and creativity.'
            },
            {
                type: 'heading',
                content: 'Looking Ahead'
            },
            {
                type: 'paragraph',
                content: 'As we move forward, the digital marketing landscape will continue to evolve. Staying informed, adaptable, and customer-focused will be key to success. Remember that at the heart of every successful campaign is a deep understanding of your audience and a commitment to delivering genuine value.'
            },
            {
                type: 'paragraph',
                content: 'Whether you\'re just starting your digital marketing journey or looking to refine your existing strategies, the principles remain the same: know your audience, provide value, and never stop learning.'
            }
        ]
    },
    {
        id: 3,
        fullContent: [
            {
                type: 'paragraph',
                content: 'In the rapidly evolving landscape of digital marketing, building brand trust through authentic content has become more critical than ever. As we navigate through 2025, businesses must adapt to new technologies and changing consumer behaviors to stay competitive.'
            },
            {
                type: 'heading',
                content: 'Understanding the Current Landscape'
            },
            {
                type: 'paragraph',
                content: 'The digital marketing ecosystem has undergone significant transformations in recent years. With the rise of artificial intelligence, machine learning, and advanced analytics, marketers now have unprecedented tools at their disposal to understand and engage with their audiences.'
            },
            {
                type: 'paragraph',
                content: 'However, with great power comes great responsibility. As these technologies become more sophisticated, so do consumer expectations. Today\'s audiences demand personalized, relevant, and timely content that speaks directly to their needs and interests.'
            },
            {
                type: 'heading',
                content: 'Key Strategies for Success'
            },
            {
                type: 'list',
                items: [
                    'Leverage data analytics to understand your audience deeply',
                    'Create authentic, value-driven content that resonates',
                    'Embrace emerging technologies while maintaining human connection',
                    'Build trust through transparency and consistency',
                    'Optimize for mobile-first experiences',
                    'Focus on long-term relationships over short-term gains'
                ]
            },
            {
                type: 'heading',
                content: 'The Role of Technology'
            },
            {
                type: 'paragraph',
                content: 'Technology should be viewed as an enabler, not a replacement for human creativity and strategic thinking. The most successful digital marketing campaigns combine cutting-edge tools with compelling storytelling and genuine human insight.'
            },
            {
                type: 'paragraph',
                content: 'Automation can handle repetitive tasks and provide valuable data, but the interpretation of that data and the creation of meaningful strategies still requires human expertise and creativity.'
            },
            {
                type: 'heading',
                content: 'Looking Ahead'
            },
            {
                type: 'paragraph',
                content: 'As we move forward, the digital marketing landscape will continue to evolve. Staying informed, adaptable, and customer-focused will be key to success. Remember that at the heart of every successful campaign is a deep understanding of your audience and a commitment to delivering genuine value.'
            },
            {
                type: 'paragraph',
                content: 'Whether you\'re just starting your digital marketing journey or looking to refine your existing strategies, the principles remain the same: know your audience, provide value, and never stop learning.'
            }
        ]
    }
];

// Helper functions
export const getBlogById = (id) => {
    return blogData.find(blog => blog.id === parseInt(id));
};

export const getBlogDetailsById = (id) => {
    return blogDetailsData.find(detail => detail.id === parseInt(id));
};

export const getRelatedBlogs = (currentId, limit = 3) => {
    return blogData.filter(blog => blog.id !== parseInt(currentId)).slice(0, limit);
};
